import React from 'react';

const ResearchBadge = ({ width = 120, height = 120, showText = true }) => (
  <blockquote
    className="badgr-badge"
    style={{
      fontFamily: 'Helvetica, Roboto, "Segoe UI", Calibri, sans-serif',
      textAlign: 'center',
      marginBottom: 48,
    }}
  >
    <a href="https://api.badgr.io/public/assertions/m4j9CbTZTF-NmAo3pj8VPA">
      <img
        style={{ width, height }}
        src="https://media.badgr.com/uploads/badges/assertion-m4j9CbTZTF-NmAo3pj8VPA.png"
        alt="research badge"
      />
    </a>
    {showText && (
      <React.Fragment>
        <p
          className="badgr-badge-name"
          style={{
            hyphens: 'auto',
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            margin: 0,
            fontSize: 16,
            fontWeight: 600,
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 1.25,
            letterSpacing: 'normal',
            textAlign: 'left',
          }}
        >
          Research-Based Design Product Certification
        </p>
        <p
          className="badgr-badge-date"
          style={{
            margin: 0,
            fontSize: 12,
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 1.67,
            letterSpacing: 'normal',
            textAlign: 'left',
          }}
        >
          <strong
            style={{
              fontSize: 12,
              fontWeight: 'bold',
              fontStyle: 'normal',
              fontStretch: 'normal',
              lineHeight: 1.67,
              letterSpacing: 'normal',
              textAlign: 'left',
            }}
          >
            Awarded:
          </strong>{' '}
          Feb 5, 2020
        </p>
      </React.Fragment>
    )}
    <script
      async="async"
      src="https://badgr.com/assets/widgets.bundle.js"
    ></script>
  </blockquote>
);

export default ResearchBadge;
